export default __webpack_public_path__ + "static/media/FAQ_12_4.1fb2f548.png";